/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useModal } from './hooks';
import { footerItemGap, keylineHeight, padding } from './internal/constants';
var footerStyles = css({
  display: 'flex',
  padding: padding,
  paddingTop: "".concat(padding - keylineHeight, "px"),
  position: 'relative',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: "".concat(footerItemGap, "px")
});

var ModalFooter = function ModalFooter(props) {
  var children = props.children,
      userDefinedTestId = props.testId;

  var _useModal = useModal(),
      modalTestId = _useModal.testId;

  var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
  return jsx("div", {
    css: footerStyles,
    "data-testid": testId
  }, children);
};

export default ModalFooter;